import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StoreMarketingMeta from 'components/commons/StoreMarketingMeta';

const Header = ({ client }) => <StoreMarketingMeta client={client} />;

Header.defaultProps = {
  client: null,
};

Header.propTypes = {
  client: PropTypes.shape(),
};

const mapStateToProps = (state) => ({
  client: state.app.client,
});

export default connect(mapStateToProps)(Header);
